function ErrorFallback() {
  return <p>Something went wrong :(</p>;
}

export default ErrorFallback;
